var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "bot-spinner",
    {
      staticClass: "bot-upload-images",
      model: {
        value: _vm.spinner,
        callback: function ($$v) {
          _vm.spinner = $$v
        },
        expression: "spinner",
      },
    },
    [
      _c("input", {
        ref: "inputFile",
        staticClass: "d-none",
        attrs: { type: "file", accept: "image/*" },
        on: { change: _vm.onImagePreview },
      }),
      _c(
        "figure",
        [
          _c("v-img", {
            attrs: {
              dark: "",
              src: _vm.src,
              alt: _vm.title,
              title: _vm.title,
              "aspect-ratio": _vm.aspectRatio,
              gradient: "to bottom, rgba(0,0,0,.1), rgba(0,0,0,.1)",
            },
            on: { click: _vm.openUpload },
            scopedSlots: _vm._u([
              {
                key: "placeholder",
                fn: function () {
                  return [
                    _c(
                      "v-row",
                      {
                        staticClass: "fill-height ma-0",
                        attrs: { "align-items": "center", justify: "center" },
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "grey lighten-5" },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("figcaption", [_vm._v(_vm._s(_vm.caption))]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/bot/upload/bot.upload.images.vue